module.exports = __webpack_public_path__ + "static/media/bank_account-arrow.6a7cab8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/bank_account-arrow.svg
// module id = 927
// module chunks = 21